
const config = {
    apiUrl: process.env.REACT_APP_API_URL,
    nodeEnv: process.env.NODE_ENV,
  };
  
  export default config;